import { STAGE } from '@/config';

export function getEyeAbleDomain() {
  const domain = process.env.SITE_ROOT?.replaceAll('https://', '').replaceAll(
    '/',
    ''
  );
  const isProd = STAGE === 'prod';

  if (!domain || !isProd) return null;

  return domain;
}
